module.exports = __webpack_public_path__ + "media/images/badges/rowhouse/16mill-inactive-53c027f0da5c90f75b6e37e33b9c54d2.png";